import { INVIEW_ENTER } from "@scroll/constants";
import { $, $$, rect } from "@utils/dom";
import { lerp } from "@utils/math";
import { mobile } from "@utils/mobile";
import { on, off } from "@utils/listener";
import ResizeOrientation, { BEFORE_SCROLL_UPDATE as MAX_PRIORITY } from "@utils/resize";

const STORAGE_NAMESPACE = 'FOOTER_COLOR';
const FPS = 1000 / 60;

class SiteFooter {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.newsletter = $('.site-footer__newsletter', this.el);
    this.side = $('.site-footer__side', this.el);
    this.logo = mobile ? null : $('.site-footer__logo', this.el);

    this._colors = (this.el.dataset.colors || '').split(',');
  }

  init() {
    if( this.newsletter ) this.newsletter = new NewsletterForm(this.newsletter);
    if( this.logo ) this.logo = new Logo(this.logo, this.emitter);

    // if we can shuffle side's background-color
    if( this.side && this._colors.length > 0 ) {
      // get value from LocalStorage
      let color = localStorage.getItem(STORAGE_NAMESPACE);

      // if we can't find value from LocalStorage OR
      // saved value doesn't exists in color options,
      // pick random color
      if( !color || !this._colors.includes(color) ) {
        color = this._colors[ Math.round( Math.random() * (this._colors.length - 1) ) ];
      }

      // apply background-color
      this.side.classList.replace('bg-color-pink', `bg-${color}`);

      // get next color
      let index = this._colors.indexOf(color) + 1;
      if( index >= this._colors.length ) index = 0;

      color = this._colors[index];

      // save next color in LocalStorage
      localStorage.setItem(STORAGE_NAMESPACE, color);
    }

    //this._bindEvents();
  }
  destroy() {
    //this._unbindEvents();

    if( this.newsletter ) this.newsletter.destroy();
    if( this.logo ) this.logo.destroy();

    this.el = null;
    this.emitter = null;
    this.newsletter = null;
    this.side = null;
    this.logo = null;

    this._colors = null;
  }

  //_bindEvents() {}
  //_unbindEvents() {}
}

const API_URL_ENDPOINT_NEWSLETTER = `https://207ouest-api.vercel.app/api/newsletter/`;
const KLAVIYO_LIST_ID_DEFAULT = `SME5mT`;
const SUBMITTING_CLASSNAME = "--submitting";
// const VALIDATION_CLASSNAME = "--validation-reported";
// const SUCCESS_CLASSNAME = "--success";
// const ERROR_CLASSNAME = "--error";
// const OUTPUT_DELAY = 5000;

class NewsletterForm {
  constructor(el) {
    this.el = el;
    this.form = $('.site-footer__newsletter__form', this.el);
    this.input = $('.site-footer__newsletter__input', this.el);
    this.button = $('.site-footer__newsletter__submit', this.el);
    this.output = $('.site-footer__newsletter__success', this.el);
    this.error = $('.site-footer__newsletter__error', this.el);

    this._tick = null;
    this._waiting = false;

    this._onSubmit = this._onSubmit.bind(this);
    this._submitSuccess = this._submitSuccess.bind(this);
    this._submitError = this._submitError.bind(this);

    this.init();
  }

  init() {
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.form = null;
    this.input = null;
    this.button = null;
    this.output = null;

    this._onSubmit = null;
    this._submitSuccess = null;
  }

  _bindEvents() {
    on(this.form, 'submit', this._onSubmit);
  }
  _unbindEvents() {
    off(this.form, 'submit', this._onSubmit);
  }

  _onSubmit(event) {
    if( this._waiting ) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // if native form validation is supported
    if( this.form.reportValidity && !this.form.reportValidity() ) return false;

    // disable button & input
    this.button.setAttribute('disabled', 'disabled');
    this.error.setAttribute('aria-hidden', 'true');

    this._send();
  }

  _send() {
    this._waiting = true;

    // set form as submitting
    this.form.classList.add(SUBMITTING_CLASSNAME);

    // get form data
    const body = new FormData(this.form);

    console.log(body.get('email'));

    // append default listid if not present
    if(!body.get('listid')) body.append('listid', KLAVIYO_LIST_ID_DEFAULT);

    // stringify POST body
    const body_encoded = new URLSearchParams(body).toString();
    console.log('body_encoded:', body_encoded)

    fetch(API_URL_ENDPOINT_NEWSLETTER, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: body_encoded
    })
      .then((res) => res.json())
      .then(this._submitSuccess)
      .catch(this._submitError)
  }

  _submitSuccess(response) {
    // set form as submitting
    this.form.classList.remove(SUBMITTING_CLASSNAME);

    if(!response.success) {
      // re-enable button
      this.button.removeAttribute('disabled');
      // show error
      this.error.removeAttribute('aria-hidden');
      return;
    };

    // show output message
    this.output.removeAttribute('aria-hidden');

    // reset value
    this.input.value = ''
    this.input.setAttribute('aria-hidden', 'true');
  }

  _submitError(error) {
    console.log('error:', error)
    this.form.classList.remove(SUBMITTING_CLASSNAME);
    // re-enable button
    this.button.removeAttribute('disabled');
  }

}


class Logo {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.parent = this.el.parentElement;
    this.letters = [ ...$$('svg:not(:first-child)', this.el) ].map((letter, index) => {
      return {
        el: letter,
        lerp: [
          0.65, // 2
          0.42, // 0
          0.4,  // 7

          0.33, // o
          0.30, // u
          0.27, // e
          0.24, // s
          0.22  // t
        ][index],
        y: 0,
      };
    });

    this._inView = false;
    this._raf = null;
    this._scrollObj = null;
    this._space = null;
    this._y = 0;
    this._lastTime = null;

    this._onResize = this._onResize.bind(this);
    this._onScrollCall = this._onScrollCall.bind(this);
    this._onScrollCall2 = this._onScrollCall2.bind(this);
    this._onRAF = this._onRAF.bind(this);

    this.init();
  }

  init() {
    this._onResize();
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    if( this._raf ) cancelAnimationFrame(this._raf);

    this.el = null;
    this.emitter = null;
    this.parent = null;
    this.letters = null;

    this._inView = null;
    this._raf = null;
    this._scrollObj = null;
    this._space = null;
    this._y = null;
    this._lastTime = null;

    this._onResize = null;
    this._onScrollCall = null;
    this._onScrollCall2 = null;
    this._onRAF = null;
  }

  _bindEvents() {
    ResizeOrientation.add(this._onResize, MAX_PRIORITY);

    this.emitter.on('SiteScroll.site-footer__logo', this._onScrollCall);
    this.emitter.on('SiteScroll.site-footer__logoWrap', this._onScrollCall2);
  }
  _unbindEvents() {
    this.emitter.off('SiteScroll.site-footer__logo', this._onScrollCall);
    this.emitter.off('SiteScroll.site-footer__logoWrap', this._onScrollCall2);

    ResizeOrientation.remove(this._onResize);
  }

  _onResize() {
    const { height } = rect(this.el);
    this._space = rect(this.parent).height - height;

    this.el.dataset.scrollOffset = `${height}px, 0px`;
  }
  _onScrollCall(direction, obj) {
    // check if event is related to this module
    if( obj.el !== this.el ) return;

    // save scroll obj
    this._scrollObj = obj;
  }
  _onScrollCall2(direction, obj) {
    // check if event is related to this module
    if( obj.el !== this.parent ) return;

    // update in-view status
    this._inView = direction === INVIEW_ENTER;

    // start RAF if not running
    if( this._inView && !this._raf ) this._onRAF();
    if( !this._inView ) {

      this._lastTime = null;
      this._y = 0;

      // snap each letters
      this.letters.forEach(letter => {
        letter.y = 0;
        letter.el.style.transform = `translate3d(0px, ${letter.y}px, 0px)`;
      });
    }
  }
  _onRAF() {
    const time = performance.now();
    const delta = this._lastTime ? Math.min(Math.ceil((time - this._lastTime) / FPS * 10) / 10, 1) : 1;

    this._lastTime = time;

    if( this._scrollObj ) {
      // calculate sticky scroll new position
      const y = this._space * this._scrollObj.progress;

      // distance from previous position
      const distance = this._y - y;

      // update previous position
      this._y = y;

      // lerp each letters
      this.letters.forEach(letter => {
        letter.y += distance;
        letter.y  = lerp(letter.y, 0, letter.lerp * delta);

        if( Math.abs(letter.y) < 0.5 ) letter.y = 0;

        letter.el.style.transform = `translate3d(0px, ${letter.y}px, 0px)`;
      });
    }

    if( this._inView ) this._raf = requestAnimationFrame(this._onRAF);
    else this._raf = null;
  }
}

export default SiteFooter;
